import * as React from 'react'
import * as THREE from 'three'

import Stage from '../Stage'
import Model from 'designer/geoHandlers/Components/Model'
import { StageStateData } from '../Types'

interface Props {
  data: StageStateData[] | undefined
}
interface State {
  data: StageStateData[]
  models: Model[]
}

class ModelLoader extends React.Component<Props, State> {
  private stage: Stage = Stage.getInstance()
  private datguiFolders: dat.GUI[] = []
  private models: THREE.Group = new THREE.Group()

  state: State = {
    data: [],
    models: [],
  }

  constructor(props: Props) {
    super(props)
    if (props.data) {
      this.state.data = props.data
    }
  }

  render() {
    return null
  }

  componentDidMount() {
    Stage.scene.add(this.models)
    for (let model of this.state.data) {
      if (model.datatype === 'saddles_designer_model') {
        const modelInstance = new Model({ ...model })
        this.setState({ models: [...this.state.models, modelInstance] })
        this.models.add(modelInstance)
      }
    }
    this.stage.update()

    const param = {
      ao_intensity: 0.6,
      normal_intensity: 1.3,
      normal_repeat: 0.6,
      mat_roughness: 0.45,
    }

    const AOFolder = Stage.datgui.addFolder('AO')
    this.datguiFolders.push(AOFolder)
    AOFolder.add(param, 'ao_intensity', 0, 1, 0.1)
      .name('AO Intensity')
      .onChange(e => {
        for (let model of this.models.children) {
          model.traverse(m => {
            if (m.type === 'Mesh') {
              const mesh = m as THREE.Mesh
              const geo = mesh.geometry
              const ao = geo.getAttribute('ao')
              const colors = geo.getAttribute('color')

              if (ao && colors) {
                for (let i = 0; i < ao.array.length; i++) {
                  const colorValue = ao.array[i] * e + (1 - e)
                  colors.setXYZ(i, colorValue, colorValue, colorValue)
                }
              }
              colors.needsUpdate = true
            }
          })
        }
        this.stage.update()
      })

    const LeatherFolder = Stage.datgui.addFolder('Leather')
    this.datguiFolders.push(LeatherFolder)
    LeatherFolder.add(param, 'normal_intensity', 0, 3, 0.1)
      .name('Intensity')
      .onChange(e => {
        for (let model of this.models.children) {
          model.traverse(m => {
            if (m.type === 'Mesh') {
              const mesh = m as THREE.Mesh
              const mat = mesh.material as THREE.MeshStandardMaterial

              mat.normalScale.x = e
              mat.normalScale.y = e

              mat.needsUpdate = true
            }
          })
        }
        this.stage.update()
      })
    LeatherFolder.add(param, 'normal_repeat', 0.1, 3, 0.1)
      .name('Size')
      .onChange(e => {
        this.stage.defLeatherNormals.repeat.set(e, e)
        for (let model of this.models.children) {
          model.traverse(m => {
            if (m.type === 'Mesh') {
              const mesh = m as THREE.Mesh
              const mat = mesh.material as THREE.MeshStandardMaterial
              mat.needsUpdate = true
            }
          })
        }
        this.stage.update()
      })
    LeatherFolder.add(param, 'mat_roughness', 0.1, 1, 0.025)
      .name('Roughness')
      .onChange(e => {
        for (let model of this.models.children) {
          model.traverse(i => {
            if (i.name === 'island') {
              i.traverse(m => {
                if (m.type === 'Mesh') {
                  const mesh = m as THREE.Mesh
                  const mat = mesh.material as THREE.MeshStandardMaterial
                  mat.roughness = e
                  mat.needsUpdate = true
                }
              })
            }
          })
        }
        this.stage.update()
      })
  }

  componentWillUnmount() {
    Stage.scene.remove(this.models)
    this.setState({ models: [] })
    this.stage.update()
    for (let folder of this.datguiFolders) {
      Stage.datgui.removeFolder(folder)
    }
  }
}

export default ModelLoader
